export default __webpack_public_path__ + "static/media/certificado-scorm.bede8d05.svg";